import React, { useState } from 'react'
import { Button, Input, Alert } from '@byscott-io/corebyscott'
import Lex from '../Shared/Lex'
import { getCsrfToken } from '../../utils/csrf'

const PasswordChange = () => {
  const [currentPassword, setCurrentPassword] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [errors, setErrors] = useState({})

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')
    setErrors({})

    if (password !== passwordConfirmation) {
      setErrors({ password_confirmation: ['Password confirmation does not match'] })
      setLoading(false)
      return
    }

    try {
      const response = await fetch('/users', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        },
        body: JSON.stringify({
          user: {
            current_password: currentPassword,
            password: password,
            password_confirmation: passwordConfirmation
          }
        })
      })

      const data = await response.json()

      if (response.ok) {
        setMessage(data.message)
        setCurrentPassword('')
        setPassword('')
        setPasswordConfirmation('')
      } else {
        setErrors(data.errors || {})
      }
    } catch (error) {
      console.error('Password change error:', error)
      setErrors({ general: ['An error occurred. Please try again.'] })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="password-change-section cbs-scope">
      <h4><Lex term="change-password" /></h4>
      
      {message && (
        <Alert color="success">{message}</Alert>
      )}
      
      {errors.general && (
        <Alert color="danger">{errors.general[0]}</Alert>
      )}

      <form onSubmit={handleSubmit}>
        <table className="p10">
          <tbody>
            <tr>
              <th className="text-right"><Lex term="current-password" /></th>
              <td>
                <Input 
                  type="password" 
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
                {errors.current_password && (
                  <div className="text-danger">{errors.current_password[0]}</div>
                )}
              </td>
            </tr>
            <tr>
              <th className="text-right"><Lex term="new-password" /></th>
              <td>
                <Input 
                  type="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  minLength="6"
                  required
                />
                {errors.password && (
                  <div className="text-danger">{errors.password[0]}</div>
                )}
              </td>
            </tr>
            <tr>
              <th className="text-right"><Lex term="confirm-password" /></th>
              <td>
                <Input 
                  type="password" 
                  value={passwordConfirmation}
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  required
                />
                {errors.password_confirmation && (
                  <div className="text-danger">{errors.password_confirmation[0]}</div>
                )}
              </td>
            </tr>
            <tr>
              <th className="text-right" />
              <td>
                <Button 
                  type="submit" 
                  color="primary" 
                  disabled={loading}
                >
                  {loading ? 'Updating...' : <Lex term="change-password" />}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  )
}

export default PasswordChange